import React from 'react';
import { Palette, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { Theme } from '../types/theme';
import ReactGA from "react-ga4";

export default function Footer() {
  const { theme, setTheme } = useTheme();

  ReactGA.initialize("G-VSK6KEH79G");
  
  const themes: { value: Theme; label: string; description: string }[] = [
    { value: 'light', label: 'Light', description: 'Clean and crisp for daytime viewing' },
    { value: 'dark', label: 'Dark', description: 'Easy on the eyes for nighttime viewing' },
    { value: 'blue', label: 'Blue', description: 'Professional finance-focused theme' },
    { value: 'japanese', label: 'Japanese', description: 'Elegant Japanese-inspired design' },
    { value: 'nature', label: 'Nature', description: 'Earth-toned professional theme' },
  ];

  return (
    <footer className="mt-auto py-8 border-t border-gray-200">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center justify-center space-y-4">
          <div className="flex items-center space-x-2">
            <Palette className="h-5 w-5 text-blue-500" />
            <select
              value={theme}
              onChange={(e) => setTheme(e.target.value as Theme)}
              className="bg-transparent border border-gray-300 rounded-md px-3 py-1.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              {themes.map(({ value, label }) => (
                <option key={value} value={value}>{label}</option>
              ))}
            </select>
          </div>
          
          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-500">
            <span>© {new Date().getFullYear()} Track-Assetz. All rights reserved.</span>
            <Link to="/blog" className="text-blue-600 hover:text-blue-500">
              Blog
            </Link>
            <Link to="/terms" className="text-blue-600 hover:text-blue-500">
              Terms & Conditions
            </Link>
            <Link to="/contact" className="text-blue-600 hover:text-blue-500 flex items-center">
              <Mail className="h-4 w-4 mr-1" />
              Contact Us
            </Link>
          </div>

          {/* Security Trust Seals */}
          <div className="flex flex-wrap justify-center items-center gap-8 mt-6 pt-6 border-t border-gray-200">
            {/* Norton Safe Web */}
            <a 
              href="https://safeweb.norton.com/report/show?url=track-assetz.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex flex-col items-center"
            >
              <img 
                src="https://images.pexels.com/photos/5473950/pexels-photo-5473950.jpeg?auto=compress&cs=tinysrgb&w=100" 
                alt="Norton Safe Web" 
                className="h-12 w-auto object-contain"
              />
              <span className="text-xs text-gray-600 mt-1">Norton Safe Web</span>
            </a>

            {/* McAfee SECURE */}
            {/* <a 
              href="https://www.mcafeesecure.com/verify?host=track-assetz.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex flex-col items-center"
            >
              <img 
                src="https://images.pexels.com/photos/5473302/pexels-photo-5473302.jpeg?auto=compress&cs=tinysrgb&w=100" 
                alt="McAfee SECURE" 
                className="h-12 w-auto object-contain"
              />
              <span className="text-xs text-gray-600 mt-1">McAfee SECURE</span>
            </a> */}

            {/* Google Transparency Report */}
            <a 
              href="https://transparencyreport.google.com/safe-browsing/search?url=track-assetz.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex flex-col items-center"
            >
              <img 
                src="https://images.pexels.com/photos/5473957/pexels-photo-5473957.jpeg?auto=compress&cs=tinysrgb&w=100" 
                alt="Google Safe Browsing" 
                className="h-12 w-auto object-contain"
              />
              <span className="text-xs text-gray-600 mt-1">Google Safe Browsing</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}